// Master-Sprint P0 — Alert Center (in-app notification hub).
import { apiClient } from "./client";

export async function fetchAlertCenter() {
  const { data } = await apiClient.get("/alert-center");
  return data;
}

export async function markAlertCenterSeen() {
  const { data } = await apiClient.post("/alert-center/seen");
  return data;
}
